<template>
  <b-modal title="Detalhes do Plano de Manutenção" v-model="show" size="xl">
    <b-container fluid>
      <b-row class="mt-2">
        <b-col cols="6">
          <b-form-group label="Detalhe:" label-for="detalhe" label-cols="3" label-align="right">
            <b-form-input id="detalhe" v-model="template.detalhe" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Local:" label-for="local" label-cols="3" label-align="right">
            <b-form-input id="local" v-model="template.local" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col cols="6">
          <b-form-group label="Resultado:" label-for="resultado" label-cols="3" label-align="right">
            <b-form-input id="resultado" v-model="template.resultado" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-group label-cols="2" label="Objetivo:" label-align="center">
            <b-form-textarea v-model="template.objetivo" rows="3"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-group label-cols="2" label="Observação:" label-align="center">
            <b-form-textarea v-model="template.observacao" rows="4"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <hr />
      <b-row>
        <b-col cols="6">
          <b-form-group label="Técnico:" label-for="tecnico" label-cols="3" label-align="right">
            <b-form-select v-model="template.inspetor">
              <b-form-select-option v-for="profissional of getProfissionais" v-bind:key="profissional.id" :value="profissional"
                >{{ profissional.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Responsável:" label-for="responsavel" label-cols="3" label-align="right">
            <b-form-select v-model="template.responsavel">
              <b-form-select-option v-for="profissional of getProfissionais" v-bind:key="profissional.id" :value="profissional"
                >{{ profissional.nome }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useProfissionalStore } from "@/stores/ProfissionalStore";
import { storeToRefs } from "pinia";
import PlanoManutencao from "@/models_reports/PlanoManutencao";

export default {
  name: "ModalDeTemplatePlanoManutencao",

  components: {},

  data() {
    return {
      show: false,
      template: new PlanoManutencao(),
    };
  },

  methods: {
    call(plano) {
      this.show = !this.show;
      this.template = plano;
    },
  },

  setup() {
    const store = useSgcqStore();
    const profissionalStore = useProfissionalStore();
    const { getProfissionais } = storeToRefs(profissionalStore);

    return {
      store,
      profissionalStore,
      getProfissionais,
    };
  },
};
</script>

<style lang="scss" scoped></style>
